import { Icon } from '@aqarmap/aqarmap-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ValuationItemType } from '~/types/valuationTypes';
import PriceIndex from '~/modules/valuation/pages/ValuationResults/PriceIndex';
import BadgeLevel from '~/modules/valuation/pages/ValuationResults/BadgeLevel';

const MarketInsights = ({
  valuationData,
}: {
  valuationData: ValuationItemType;
}) => {
  const { t } = useTranslation('app');

  return (
    <div className="flex flex-col gap-3x">
      <p className="text-title_4">{t('marketAnalysisTitle')}</p>
      <div className="flex flex-col-reverse md:flex-row gap-2x md:gap-4x">
        <div className="flex-1 flex flex-col gap-2x md:gap-4x">
          <div className="flex-1 rounded-[14px] border border-gray flex flex-col gap-3x px-3x py-2x md:py-3x">
            <div className="flex gap-1.5x">
              <div className="w-10 h-10 rounded-[8px] bg-gray_light_2 flex justify-center items-center">
                <Icon name="users" className="text-gray__dark_2" size="24px" />
              </div>
              <div className="flex flex-col gap-x">
                <p className="text-body_1 text-gray__dark_2">
                  {t('marketSampleSize')}
                </p>
                <p className="text-caption text-gray__dark_1">
                  {t('numberOfListingsAnalyzed')}
                </p>
              </div>
            </div>
            <div className="flex justify-between items-center">
              <p className="text-title_4 md:text-title_3">
                {valuationData.currentValuation.sampleSize}
              </p>
              <BadgeLevel
                level={valuationData.currentValuation.sampleSizeLevel}
                variant="secondary"
              />
            </div>
          </div>
          <div className="flex-1 rounded-[14px] border border-gray flex flex-col gap-3x px-3x py-2x md:py-3x">
            <div className="flex gap-1.5x">
              <div className="w-10 h-10 rounded-[8px] bg-gray_light_2 flex justify-center items-center">
                <Icon
                  name="bar-chart"
                  className="text-gray__dark_2"
                  size="24px"
                />
              </div>
              <div className="flex flex-col gap-x">
                <p className="text-body_1 text-gray__dark_2">
                  {t('demandIndicator')}
                </p>
                <p className="text-caption text-gray__dark_1">
                  {t('demandIndicatorLabel')}{' '}
                </p>
              </div>
            </div>
            <div className="flex justify-between items-center">
              <p className="text-title_4 md:text-title_3">
                {valuationData.currentValuation.demandLevelPercentage}%
              </p>
              <BadgeLevel level={valuationData.currentValuation.demandLevel} />
            </div>
          </div>
        </div>
        <PriceIndex valuationData={valuationData} />
      </div>
    </div>
  );
};

export default MarketInsights;
